import React, {Component} from "react"
import { Link } from "react-router-dom"

class Button extends Component {
  render() {
    switch(this.props.type) {
      case 'download':
        return (
          <button onClick={this.props.onClick} className={`px-4 py-3 rounded-md bg-orange text-white text-xs font-semibold ease-in-out duration-300 focus:outline-none inline-flex items-center ${this.props.className}`}>
            <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg>
            <span>{this.props.children}</span>
          </button>
        )
      case 'filter':
        return <button onClick={this.props.onClick} className={`px-6 py-3 inline-block rounded-lg hover:text-white active:text-white font-semibold text-sm md:text-base lg:text-md hover:bg-orange active:bg-orange ease-in-out duration-300 focus:outline-none ${this.props.className}`}>{this.props.children}</button>
      case 'submit':
        return <button onClick={this.props.onClick} className={`px-6 py-3 rounded-md bg-orange text-white font-semibold ease-in-out duration-300 focus:outline-none ${this.props.className}`} type="submit">{this.props.children}</button>
      case 'primary':
        return <Link to={this.props.link} className={`px-6 py-3 inline-block rounded-lg bg-orange text-white text-sm md:text-base lg:text-md hover:bg-darkorange ease-in-out duration-300 focus:outline-none ${this.props.className}`}>{this.props.children}</Link>
      case 'secondary':
        return <Link to={this.props.link} className={`px-6 py-3 inline-block rounded-lg bg-black text-white text-sm md:text-base lg:text-md hover:bg-gray-800 ease-in-out duration-300 focus:outline-none ${this.props.className}`}>{this.props.children}</Link>
      case 'disabled':
        return <Link to={this.props.link} className={`px-6 py-3 inline-block rounded-lg bg-orange text-white text-sm md:text-base lg:text-md hover:bg-darkorange ease-in-out duration-300 focus:outline-none ${this.props.className}`}>{this.props.children}</Link>
      default:
        return <Link to={this.props.link} className="px-6 py-3 inline-block rounded-lg bg-orange text-white">{this.props.children}</Link>
    }
  }
}
  export default Button
